import { render, staticRenderFns } from "./FourPup.vue?vue&type=template&id=b5cfc2ee&scoped=true"
import script from "./FourPup.vue?vue&type=script&lang=js"
export * from "./FourPup.vue?vue&type=script&lang=js"
import style0 from "./FourPup.vue?vue&type=style&index=0&id=b5cfc2ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5cfc2ee",
  null
  
)

export default component.exports